import { render, staticRenderFns } from "./SingleContent.vue?vue&type=template&id=b714a0a4"
import script from "./SingleContent.vue?vue&type=script&lang=js"
export * from "./SingleContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports